import { trackStandardizedEvent } from '@/utils/segment/trackStandardizedEvent';
import { SegmentEvents } from '../../constants/segment-events';
import { SplitCache } from './SplitCache';

/**
 * Handles split treatment changes, including tracking and caching
 * 
 * @param featureFlag The feature flag name
 * @param treatment The treatment value received from Split
 * @param key The user key for cache isolation
 * @param trackEvent The tracking event function from useSegmentEvent
 */
export const handleSplitTreatment = (
  featureFlag: string,
  treatment: string,
  key: string | null,
  trackEvent: (event: string, properties?: Record<string, any>) => void
): void => {
  // Check if we should track this change
  if (SplitCache.shouldTrack(featureFlag, treatment, key)) {
    // Track the event
    trackStandardizedEvent(
      trackEvent,
      SegmentEvents.ExperimentEvaluated,
      {
        experiment_name: featureFlag,
        experiment_variant: treatment,
      }
    );
    
    // Update cache with new value
    SplitCache.setCachedValue(featureFlag, treatment, key);
  }
};
